import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6025574d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-bar-container"
}
const _hoisted_2 = { class: "cookie-bar" }
const _hoisted_3 = { class: "cookie-bar-btns" }

import { useCookieConsent } from '@/store/useCookieConsent';


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieBar',
  setup(__props) {

const { hasCookieConsentValue, setCookieConsent } = useCookieConsent();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "quick-slide-fade" }, {
    default: _withCtx(() => [
      (!_unref(hasCookieConsentValue))
        ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, [
                _createTextVNode(" Om je bezoek aan deze site prettig en persoonlijk te maken gebruiken we cookies en vergelijkbare technieken. Geef aan of je hiermee akkoord gaat. Je leest er alles over in onze "),
                _createVNode(_component_router_link, { to: "/content/privacy" }, {
                  default: _withCtx(() => [
                    _createTextVNode("privacyverklaring")
                  ]),
                  _: 1
                }),
                _createTextVNode(". ")
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "outline-btn",
                  onClick: _cache[0] || (_cache[0] = () => _unref(setCookieConsent)(true))
                }, "Akkoord"),
                _createElementVNode("button", {
                  class: "cancel-btn link-btn",
                  onClick: _cache[1] || (_cache[1] = () => _unref(setCookieConsent)(false))
                }, "Liever niet")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})